module.exports = __webpack_public_path__ + "img/50f3.1c98166b.jpg";